export default __webpack_public_path__ + "static/media/uw2.47480ca1.png";